import { render, staticRenderFns } from "./documentRequestDetail.vue?vue&type=template&id=25175ac2&"
import script from "./documentRequestDetail.vue?vue&type=script&lang=js&"
export * from "./documentRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports